import React, { useEffect } from 'react';
import TableList from '../../../../core/table/TableList';
import TableTop from '../../../../core/table/TableTop';
import TableHead from '../../../../core/table/TableHead';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import { useProcessingErrorsTableInit } from './useProcessingErrorsTableInit';
import { useProcessingErrorsTableState } from './useProcessingErrorsTableState';
import { useProcessingErrorsData } from './useProcessingErrorsData';
import { useDataMonitorStore } from '../pagehooks/useDataMonitorStore';
import TableSkeleton from '../../../../core/components/TableSkeleton';
import { useMountingSkeleton } from '../../../../core/hooks/useMountingSkeleton';

const ProcessingErrorsTable = ({ isVerity = false }: { isVerity?: boolean }): JSX.Element => {
    const mounting = useMountingSkeleton();
    const { facilityVal } = useDataMonitorStore();
    const { init, loadProcessingErrors } = useProcessingErrorsTableInit(isVerity);
    const { waiting, cols, sections, sort, filters, fltStats, paging, setSort, setFilter, setPaging } =
        useProcessingErrorsTableState();
    const { items } = useProcessingErrorsData();

    useEffect(() => {
        if (init) return;
        if (isVerity) {
            // VERITY has no facility scope; load on mount
            loadProcessingErrors('');
        } else if (facilityVal && facilityVal !== 'NONE') {
            loadProcessingErrors(facilityVal);
        }
    }, [init, isVerity, facilityVal, loadProcessingErrors]);

    if (mounting || init || waiting) {
        return (
            <TableSkeleton
                columns={isVerity ? 6 : 4}
                rows={8}
                sections={isVerity ? 3 : 2}
            />
        );
    }

    return (
        <TableList>
            <TableTop
                id="processingErrorsTable"
                fltStats={fltStats}
            />
            <table>
                <TableHead
                    cols={cols}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    cols={cols}
                    rows={items}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default ProcessingErrorsTable;
